"use strict";
import { WOW } from "wowjs";
import $ from "jquery";

document.onload = function () {
  // WOW active
  new WOW().init();
};

//===== Preloader
window.onload = function () {
  window.setTimeout(fadeout, 500);
  setFormValidation();
};

function fadeout() {
  document.querySelector(".preloader").style.opacity = "0";
  document.querySelector(".preloader").style.display = "none";
}

/*=====================================
  Sticky
  ======================================= */
window.onscroll = function () {
  var header_navbar = document.querySelector(".navbar-area");
  var sticky = header_navbar.offsetTop;

  if (window.pageYOffset > sticky) {
    header_navbar.classList.add("sticky");
  } else {
    header_navbar.classList.remove("sticky");
  }
};

function setFormValidation() {
  const downloadForm = document.getElementById("downloadForm");
  const walletAddressInput = document.getElementById("walletAddressInput");
  const emailInput = document.getElementById("emailInput");
  const submitBtn = document.getElementById("submitBtn");

  downloadForm.addEventListener(
    "submit",
    function (event) {
      event.preventDefault();
      event.stopPropagation();
      document.getElementById("successAlert").classList.add("d-none");
      document.getElementById("invalidEmailAlert").classList.add("d-none");
      document.getElementById("notRegisteredAlert").classList.add("d-none");
      if (downloadForm.checkValidity()) {
        walletAddressInput.setAttribute("disabled", "true");
        emailInput.setAttribute("disabled", "true");
        submitBtn.setAttribute("disabled", "true");
        $.getJSON("/api/v1/verify-wallet-address", {
          download: true,
          email: emailInput.value,
          walletAddress: walletAddressInput.value,
        })
          .done(function (data) {
            if (data.msg === "Wallet is registered. Download link sent.") {
              document
                .getElementById("successAlert")
                .classList.remove("d-none");
            } else if (
              data.msg === "Wallet is registered. Plase provide a valid email."
            ) {
              walletAddressInput.removeAttribute("disabled");
              emailInput.removeAttribute("disabled");
              submitBtn.removeAttribute("disabled");
              submitBtn.innerText("Downloaded");

              document
                .getElementById("invalidEmailAlert")
                .classList.remove("d-none");
            }
          })
          .fail(function () {
            walletAddressInput.removeAttribute("disabled");
            emailInput.removeAttribute("disabled");
            submitBtn.removeAttribute("disabled");

            document
              .getElementById("notRegisteredAlert")
              .classList.remove("d-none");
          });
      }

      downloadForm.classList.add("was-validated");
    },
    false
  );
}
